module.exports = __webpack_public_path__ + "img/logo-negative.a8a45201.svg";